import { connect } from "react-redux";
import moment from 'moment-timezone';
import _ from 'lodash';
import { formValueSelector, reduxForm } from "redux-form";
import PersonalInformationTab from "../../../../itrust_common/components/authorised/patientFormPartial/PersonalInformationTab";
import AddressTab from "../../../../itrust_common/components/authorised/patientFormPartial/AddressTab";
import InsuranceWrap from "../../../../itrust_common/components/authorised/patientFormPartial/InsuranceWrap";
import PrimaryPhysicianTab from "../../../../itrust_common/components/authorised/patientFormPartial/PrimaryPhysicianTab";
import TermOfServiceTab from "../../../../itrust_common/components/authorised/patientFormPartial/TermOfServiceTab";
import { ternaryIsPresentInObj } from "../../../../itrust_common/components/HelperFunctions";
import ScrollToTarget from "../../../../itrust_common/components/others/ScrollToTarget";
import { CountriesStates } from "../../../../itrust_common/components/CountriesStates";


function SecondaryPatientForm(props) {
  const { handleSubmit, template, isLongForm, homeSelectedCountry, homeRegions, officeSelectedCountry, officeRegions } = props

  return (
    <form onSubmit={handleSubmit}>
      <div id="patient-personal-tab">
        <PersonalInformationTab
          template={template}
          isTemplate={false}
          isLongForm={isLongForm}
          formName="secondaryPatientForm"
        />
      </div>
      {isLongForm === true &&
        <div id="patient-address-tab">
          <AddressTab
            template={template}
            isTemplate={false}
            homeSelectedCountry={homeSelectedCountry}
            homeRegions={homeRegions}
            officeSelectedCountry={officeSelectedCountry}
            officeRegions={officeRegions}
          />
        </div>
      }
      <InsuranceWrap
        template={template}
        isTemplate={false}
        isLongForm={isLongForm}
        formName="secondaryPatientForm"
      />
      {isLongForm === true &&
        <>
          <div id="patient-primary-physician-tab">
            <PrimaryPhysicianTab
              template={template}
              isTemplate={false}
            />
          </div>
          <div id="patient-term-of-service-tab">
            <TermOfServiceTab
              template={template}
              isTemplate={false}
            />
          </div>
        </>
      }
    </form>
  )
}

SecondaryPatientForm = reduxForm({
  form: 'secondaryPatientForm',
  enableReinitialize: true,
  shouldValidate: () => true,
  onSubmitFail: () => ScrollToTarget()
})(SecondaryPatientForm)

const selector = formValueSelector('secondaryPatientForm');

const mapStateToProps = (state) => {
  const { organisation: { organisation }, dashboard: { quickAction } } = state

  const { patient_template } = state.setting.patientTemplate
  const patientAddress = quickAction.patient?.home_address_attributes
  const organisationAddress = organisation.address_attributes
  const homeCountryData = _.find(CountriesStates, { countryName: selector(state, 'home_address_attributes[country]') })
  const officeCountryData = _.find(CountriesStates, { countryName: selector(state, 'office_address_attributes[country]') })

  // const insurancePatientAddressValue = selector(state, 'home_address_attributes', 'primary_insurer')
  // formate recall_reminder_date so, that it can be shown prefill
  // patient.recall_reminder_date = patient.recall_reminder_date ? moment(patient.recall_reminder_date).format("YYYY/MM/DD") : patient.recall_reminder_date;

  return {
    // insurancePatientAddressValue,
    homeSelectedCountry: homeCountryData && homeCountryData.countryName,
    homeRegions: homeCountryData ? homeCountryData.regions : [],
    officeSelectedCountry: officeCountryData && officeCountryData.countryName,
    officeRegions: officeCountryData ? officeCountryData.regions : [],
    template: patient_template,
    initialValues: {
      ...quickAction.patient,
      // ...patient,
      // pending_signup: false,
      home_address_attributes: {
        ...patientAddress,
        country: ternaryIsPresentInObj(patientAddress, 'country', organisationAddress, 'country'),
        state: ternaryIsPresentInObj(patientAddress, 'state', organisationAddress, 'state'),
      }
    }
  }
}

export default connect(mapStateToProps)(SecondaryPatientForm);